import PropTypes from 'prop-types'

import {onlyIfForm, useSelector} from '../../../../store.js'
import ConfirmModal from '../../../../common/components/Modal/ConfirmModal.js'
import ButtonPrimary from '../../../../common/components/Button/ButtonPrimary.js'
import TagFilterPanel from './TagFilterPanel.js'
import {
  closeModal,
  errorsSelector,
  modalFormSelector,
  applyFilter,
  STATUS_FILTER_PANEL,
  TAG_FILTER,
  SUPPLIER_FILTER_PANEL,
  WAREHOUSE_FILTER_PANEL,
  clearFilters,
  DATE_RANGE_FILTER_PANEL,
  updateModalForm,
  SKU_FILTER_PANEL,
  PO_ID_FILTER_PANEL,
  PO_LIST_FILTER_OPTIONS,
} from './poListFilterModalFunctions.js'
import StatusFilterPanel from './StatusFilterPanel.js'
import SupplierFilterPanel from './SupplierFilterPanel.js'
import WarehouseFilterPanel from './WarehouseFilterPanel.js'
import Icon from '../../../../common/icons/Icon.js'
import {validPODateRangeFilterTypesOptionsSelector} from '../../purchaseOrderListSelectors.js'
import DateRangeFilterPanel from '../../../OrderListPage/Modals/OrderListFilterModal/DateRangeFilterPanel.js'
import SKUFilterPanel from '../../../OrderListPage/Modals/OrderListFilterModal/SKUFilterPanel.js'
import POIDFilterPanel from './POIDFilterPanel.js'
import {
  filterOrderSelector,
  showFilterSettingsModal,
} from '../../../Modals/FilterSettingsModal.js'

const FILTER_PANEL_LIST = {
  [STATUS_FILTER_PANEL]: StatusFilterPanel,
  [TAG_FILTER]: TagFilterPanel,
  [SUPPLIER_FILTER_PANEL]: SupplierFilterPanel,
  [WAREHOUSE_FILTER_PANEL]: WarehouseFilterPanel,
  [DATE_RANGE_FILTER_PANEL]: DateRangeFilterPanel,
  [SKU_FILTER_PANEL]: SKUFilterPanel,
  [PO_ID_FILTER_PANEL]: POIDFilterPanel,
}
const FILTER_ORDER_SETTINGS_KEY = 'po_list_filter_order'

function showPOListFilterSettingsModal() {
  showFilterSettingsModal({
    title: 'Purchase Order Filters Settings',
    userSettingsKey: FILTER_ORDER_SETTINGS_KEY,
    listOptions: PO_LIST_FILTER_OPTIONS,
  })
}

function POListFilterModal() {
  const filterList = useSelector((state) =>
    filterOrderSelector(state, {
      userSettingsKey: FILTER_ORDER_SETTINGS_KEY,
      listOptions: PO_LIST_FILTER_OPTIONS,
    }),
  )

  return (
    <ConfirmModal
      title="Purchase Order Filters"
      modalSize="md"
      className="modal--order-list-filters"
      onConfirm={() => applyFilter()}
      onCancel={() => closeModal()}
      confirmText="Apply"
      cancelText="Cancel"
      preventHotKeyConfirm
      RightButtons={() => (
        <div className="flex--justify">
          <ButtonPrimary
            isOutlined
            className="btn--sm margin-right-10"
            onClick={() => clearFilters()}
          >
            Clear Filters
          </ButtonPrimary>
          <ButtonPrimary
            isOutlined
            className="btn--sm"
            onClick={() => showPOListFilterSettingsModal()}
          >
            <Icon name="sym-settings" className="fs-01" />
          </ButtonPrimary>
        </div>
      )}
    >
      {filterList.map((item) => {
        const Panel = FILTER_PANEL_LIST[item]

        return Panel ? (
          <Panel
            key={item}
            modalFormSelector={modalFormSelector}
            errorsSelector={errorsSelector}
            updateModalForm={updateModalForm}
            modalValidDateRangeFilterTypesOptionsSelector={
              validPODateRangeFilterTypesOptionsSelector
            }
          />
        ) : null
      })}
    </ConfirmModal>
  )
}

POListFilterModal.propTypes = {
  form: PropTypes.shape({
    searchText: PropTypes.string.isRequired,
    status: PropTypes.arrayOf(PropTypes.string).isRequired,
    tags: PropTypes.arrayOf(PropTypes.string).isRequired,
    untagged: PropTypes.bool.isRequired,
    tag_filter_by: PropTypes.string.isRequired,
    exclude_tags: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
}

export default onlyIfForm(POListFilterModal, modalFormSelector)
